import React from 'react';
import { chunk, compact } from 'lodash-es';
import PropTypes from 'prop-types';
import { AnimationSchedule } from 'site-modules/canvas/components/animation-schedule/animation-schedule';

function getAnimationGroupKey(unitId, childIndex, groupIndex) {
  return `${unitId}:${childIndex}:${groupIndex}`;
}

export const WordByWordRenderer = React.memo(
  ({
    children = null,
    tag: Tag,
    unitId = 'word',
    isAnimationDisabled = false,
    blocksFollowing = false,
    ...restProps
  }) => {
    return (
      <Tag {...restProps}>
        {isAnimationDisabled
          ? children
          : React.Children.map(children, (child, childIndex) => {
              if (typeof child === 'string') {
                const groups = chunk(compact(child.split(/(\s+|\/)/)), 3).map(g => g.join(''));

                return groups.map((group, groupIndex) => {
                  const animationUnitId = getAnimationGroupKey(unitId, childIndex, groupIndex);

                  return (
                    <AnimationSchedule.TextChunkAnimation
                      key={animationUnitId}
                      unitId={animationUnitId}
                      blocksFollowing={blocksFollowing && groupIndex === 0}
                    >
                      {group}
                    </AnimationSchedule.TextChunkAnimation>
                  );
                });
              }
              return child;
            })}
      </Tag>
    );
  }
);

WordByWordRenderer.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.elementType]).isRequired,
  unitId: PropTypes.string,
  children: PropTypes.node,
  isAnimationDisabled: PropTypes.bool,
  blocksFollowing: PropTypes.bool,
};
